import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/components/Main'

import Login from '@/components/Login'
import Suppliers from '@/components/Suppliers'
import Categories from '@/components/Categories'
import Customer from '@/components/Customer'
import Rate from '@/components/Rate'
import Unit from '@/components/Unit'
import Products from '@/components/Products'
import Promotion from '@/components/Promotion'
import CustomProductPrice from '@/components/CustomProductPrice'
import CustomProductPriceCount from '@/components/CustomProductPriceCount'
import Import from '@/components/Import'
import StockIn from '@/components/StockIn'
import Export from '@/components/Export'
import StockOut from '@/components/StockOut'
import Stock from '@/components/Stock'
import Report from '@/components/Report'
import ReportStock from '@/components/ReportStock'
import ReportStockPro from '@/components/ReportStockPro'
import ReportSale from '@/components/ReportSale'
import ReportSale3m from '@/components/ReportSale3m'
import ReportSaleBill from '@/components/ReportSaleBill'
import ReportStockUser from '@/components/ReportStockUser'
import ReportStock3m from '@/components/ReportStock3m'
import ReportStockCat from '@/components/ReportStockCat'
import ReportImport from '@/components/ReportImport'
import ReportImportCat from '@/components/ReportImportCat'
import Tracking from '@/components/Tracking'
import Seller from '@/components/Seller'
import Branches from '@/components/Branches'
import ReportAll from '@/components/ReportAll'
import ReportYear from '@/components/ReportYear'
import Setting from '@/components/Setting'
import Finance from '@/components/Finance'
import Financelist from '@/components/Financelist'
import Finheader from '@/components/Finheader'

import 'vuetify/dist/vuetify.min.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css' 
import Vuetify from 'vuetify'
import firebase from 'firebase/app'
//import db from '@/firebase/init'
Vue.use(Vuetify)
Vue.use(Router)

const routers = new Router({
  mode:'history',
  routes: [
    {
      path: '/',
      name: 'Main',
      component: Main,
      meta:{
        requiresAuth:true
      }
    },
    {
      path: '/suppliers',
      name: 'Suppliers',
      component: Suppliers,
      meta:{
        requiresAuth:true
      }
    },
    {
      path: '/categories',
      name: 'Categories',
      component: Categories,
      meta:{
        requiresAuth:true
      }
    },
    {
      path: '/customer',
      name: 'Customer',
      component: Customer,
      meta:{
        requiresAuth:true
      }
    },
    {
      path: '/customer/:id/product/',
      name: 'CustomProductPrice',
      component:CustomProductPrice,
      meta:{
        requiresAuth:true
      }
    },
    {
      path: '/customer/:id/product/:proid/price/',
      name: 'CustomProductPriceCount',
      component:CustomProductPriceCount,
      meta:{
        requiresAuth:true
      }
    },
    {
      path: '/rate',
      name: 'Rate',
      component:Rate,
      meta:{
        requiresAuth:true
      }
    },
    {
      path: '/products',
      name: 'Products',
      component:Products,
      meta:{
        requiresAuth:true
      }
    },
    {
      path: '/import',
      name: 'Import',
      component:Import,
      meta:{
        requiresAuth:true
      }
    },
    {
      path: '/tracking',
      name: 'Tracking',
      component:Tracking,
      meta:{
        requiresAuth:true
      }
    },
    {
      path: '/import/:id/stock-in',
      name: 'StockIn',
      component:StockIn,
      meta:{
        requiresAuth:true
      }
    },
    {
      path: '/export',
      name: 'Export',
      component:Export,
      meta:{
        requiresAuth:true
      }
    },
    {
      path: '/export/:id/stock-out',
      name: 'StockOut',
      component:StockOut,
      meta:{
        requiresAuth:true
      }
    },
    {
      path: '/stock',
      name: 'Stock',
      component:Stock,
      meta:{
        requiresAuth:true
      }
    },
    {
      path: '/promotion/:id',
      name: 'Promotion',
      component:Promotion,
      meta:{
        requiresAuth:true
      }
    },
    {
      path: '/unit',
      name: 'Unit',
      component:Unit,
      meta:{
        requiresAuth:true
      }
    },
    {
      path: '/customer/:id/branches',
      name: 'Branches',
      component:Branches,
      meta:{
        requiresAuth:true
      }
    },
    {
      path: '/Report/:id',
      name: 'Report',
      component:Report,
      meta:{
        requiresAuth:true
      }
    },
    {
      path: '/ReportStock/:id',
      name: 'ReportStock',
      component:ReportStock,
      meta:{
        requiresAuth:true
      }
    },
    {
      path: '/ReportStockPro/',
      name: 'ReportStockPro',
      component:ReportStockPro,
      meta:{
        requiresAuth:true
      }
      //,
    //  props: (route) => ({ query: route.query.startdate })
    },
    {
      path: '/ReportSale',
      name: 'ReportSale',
      component:ReportSale,
      meta:{
        requiresAuth:true
      }
    },
    {
      path: '/ReportSale3m',
      name: 'ReportSale3m',
      component:ReportSale3m,
      meta:{
        requiresAuth:true
      }
    },
    {
      path: '/ReportSaleBill',
      name: 'ReportSaleBill',
      component:ReportSaleBill,
      meta:{
        requiresAuth:true
      }
    },
    {
      path: '/ReportAll',
      name: 'ReportAll',
      component:ReportAll,
      meta:{
        requiresAuth:true
      }
    },    
    {
      path: '/ReportStockUser',
      name: 'ReportStockUser',
      component:ReportStockUser,
      meta:{
        requiresAuth:true
      }
    },
    {
      path: '/ReportStock3m',
      name: 'ReportStock3m',
      component:ReportStock3m,
      meta:{
        requiresAuth:true
      }
    },    
    {
      path: '/ReportStockCat',
      name: 'ReportStockCat',
      component:ReportStockCat,
      meta:{
        requiresAuth:true
      }
    },
    {
      path: '/ReportImport',
      name: 'ReportImport',
      component:ReportImport,
      meta:{
        requiresAuth:true
      }
    },
    {
      path: '/ReportImportCat',
      name: 'ReportImportCat',
      component:ReportImportCat,
      meta:{
        requiresAuth:true
      }
    },
    {
      path: '/ReportYear',
      name: 'ReportYear',
      component:ReportYear,
      meta:{
        requiresAuth:true
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        plainLayoutLogin: true,
      }
    },
    {
      path: '/Seller',
      name: 'Seller',
      component: Seller,
      meta: {
        requiresAuth: true,
      }
    },
    {
      path: '/setting',
      name: 'seting',
      component: Setting,
      meta: {
        requiresAuth: true,
      }
    },
    {
      path: '/finance',
      name: 'finance',
      component: Finance,
      meta: {
        requiresAuth: true,
      }
    },
    {
      path: '/finance/:id',
      name: 'financelist',
      component: Financelist,
      meta:{
        requiresAuth:true
      }
    },
    {
      path: '/finheader',
      name: 'finheader',
      component: Finheader,
      meta:{
        requiresAuth:true
      }
    }
  ]
})

routers.beforeEach((to,from,next)=>{
  // check to see if route requires auth
  if(to.matched.some(rec=>rec.meta.requiresAuth)){
    //check auth state of user
    let user = firebase.auth().currentUser
    //console.log(user)
    if(user){
      next()
    }
    else{
      next({name:'Login'})
    }
  }else{
    next()
  }
})

export default routers


// WEBPACK FOOTER //
// ./src/router/index.js